import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const getFormattedDate = date => dayjs.utc(date).local().format('M/D/YY h:mma')

export const getSemanticDate = date => dayjs.utc(date).local().format('MMMM D, YYYY [at] h:mm A')
export const getFilenameDate = date => dayjs.utc(date).local().format('YYYY-MM-DD-HH-mm-ss')
